var _style, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaSearchPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "82.6px",
    height: "82.6px",
    viewBox: "0 0 82.6 82.6",
    style: {
      enableBackground: "new 0 0 82.6 82.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#003C7A;}\n\t.st2{display:inline;fill:#003C7A;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st3{display:inline;fill:#003C7A;stroke:#F2F2F2;stroke-miterlimit:10;}\n\t.st4{fill:#003C7A;}\n\t.st5{fill:#003C7A;stroke:#F2F2F2;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 41.3,
    cy: 41.3,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.5,27.4l7.3,7.3c0.3,0.3,0.3,0.8,0,1.1L43.1,53.4l-7.5,0.8c-1,0.1-1.9-0.7-1.7-1.7l0.8-7.5l17.7-17.7 C52.7,27,53.2,27,53.5,27.4L53.5,27.4z M66.6,25.5l-3.9-3.9c-1.2-1.2-3.2-1.2-4.5,0l-2.9,2.9c-0.3,0.3-0.3,0.8,0,1.1l7.3,7.3 c0.3,0.3,0.8,0.3,1.1,0l2.9-2.9C67.8,28.7,67.8,26.7,66.6,25.5z M52,48.6v8.2H26.1V31h18.6c0.3,0,0.5-0.1,0.7-0.3l3.2-3.2 c0.6-0.6,0.2-1.7-0.7-1.7H24.8c-2.1,0-3.9,1.7-3.9,3.9v28.5c0,2.1,1.7,3.9,3.9,3.9h28.5c2.1,0,3.9-1.7,3.9-3.9V45.4 c0-0.9-1-1.3-1.7-0.7l-3.2,3.2C52.1,48.1,52,48.4,52,48.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 41.3,
    cy: 41.3,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.6,45.5c0,1-0.8,1.8-1.8,1.8H47.2v13.6c0,1-0.8,1.8-1.8,1.8h-8.3c-1,0-1.8-0.8-1.8-1.8V47.2H21.8 c-1,0-1.8-0.8-1.8-1.8v-8.3c0-1,0.8-1.8,1.8-1.8h13.6V21.8c0-1,0.8-1.8,1.8-1.8h8.3c1,0,1.8,0.8,1.8,1.8v13.6h13.6 c1,0,1.8,0.8,1.8,1.8V45.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 41.3,
    cy: 41.3,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19.1,18c-0.6,0-1.1,0.5-1.1,1.1v18.5c0,0.6,0.5,1.1,1.1,1.1h18.5c0.6,0,1.1-0.5,1.1-1.1v-4.4c0,0,0,0,0-0.1 c0-0.6-0.5-1.1-1.2-1.1l-9.4,0.4c0.4-0.6,0.8-1.1,1.3-1.7c5.9-6.7,16.2-7.4,22.9-1.5s7.4,16.2,1.5,22.9S37.7,59.8,31,53.9 c-0.4-0.4-1.1-0.4-1.5,0.1l-3.1,3.1c0,0,0,0,0,0c-0.4,0.5-0.4,1.2,0.1,1.6c4.2,3.8,9.7,5.9,15.4,5.9c12.6,0,22.9-10.2,22.9-22.9 c0-12.6-10.3-22.9-22.9-22.9c-6.7,0-13.1,2.9-17.5,8.1l0.4-7.6c0,0,0,0,0-0.1c0-0.6-0.5-1.1-1.1-1.1H19.1L19.1,18z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 41.3,
    cy: 41.3,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M45.6,33.1v3.3c0,0.7-0.6,1.2-1.2,1.2h-5.7v5.7c0,0.7-0.6,1.2-1.2,1.2h-3.3c-0.7,0-1.2-0.6-1.2-1.2v-5.7h-5.7 c-0.7,0-1.2-0.6-1.2-1.2v-3.3c0-0.7,0.6-1.2,1.2-1.2H33v-5.7c0-0.7,0.6-1.2,1.2-1.2h3.3c0.7,0,1.2,0.6,1.2,1.2v5.7h5.7 C45,31.8,45.6,32.4,45.6,33.1z M66.1,62.1l-2.9,2.9c-1,1-2.5,1-3.5,0L49.6,54.8c-0.5-0.5-0.7-1.1-0.7-1.7v-1.7 c-3.6,2.8-8.1,4.5-13,4.5c-11.7,0-21.2-9.5-21.2-21.2s9.5-21.2,21.2-21.2S57,23,57,34.7c0,4.9-1.7,9.4-4.5,13h1.7 c0.7,0,1.3,0.3,1.7,0.7l10.2,10.2C67,59.6,67,61.1,66.1,62.1z M49.7,34.7c0-7.7-6.2-13.9-13.9-13.9S22,27,22,34.7 s6.2,13.9,13.9,13.9S49.7,42.3,49.7,34.7z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 41.3,
    cy: 41.3,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45.1,49.5h-7c-1.2,0-2.1-0.9-2.1-2.1V32.7h-7.7c-1.6,0-2.3-1.9-1.2-3l13.3-13.3c0.7-0.7,1.7-0.7,2.4,0 l13.3,13.3c1.1,1.1,0.3,3-1.2,3h-7.7v14.7C47.2,48.6,46.3,49.5,45.1,49.5z M64,48.8v9.8c0,1.2-0.9,2.1-2.1,2.1H21.3 c-1.2,0-2.1-0.9-2.1-2.1v-9.8c0-1.2,0.9-2.1,2.1-2.1h11.9v0.7c0,2.7,2.2,4.9,4.9,4.9h7c2.7,0,4.9-2.2,4.9-4.9v-0.7h11.9 C63.1,46.7,64,47.7,64,48.8z M53.2,56.5c0-1-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8C52.4,58.3,53.2,57.5,53.2,56.5z  M58.8,56.5c0-1-0.8-1.8-1.8-1.8s-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8S58.8,57.5,58.8,56.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaSearchPlus);
export default __webpack_public_path__ + "static/media/fa-search-plus.4b5cfe9bd57998be5f9528fd9a0af43f.svg";
export { ForwardRef as ReactComponent };